/** Erro de fetch das rotas de export/availability, com o status para o toast. */
export class ProgramResponsesFetchError extends Error {
  readonly name = 'ProgramResponsesFetchError';
  constructor(
    message: string,
    readonly status: number
  ) {
    super(message);
  }
}
